export class EventService {
    static EVENTS = {
        api_error: 'ServicesContext.api.call().api_error',
        update_collision: 'ServicesContext.api.call().update_collision',
    };

    constructor() {
        this.subscribers = {};
        this.events = {};
        this.init(EventService.EVENTS);
    }

    /**
     * @param {object} events
     */
    init(events) {
        // Initialize events
        if (events && typeof events === 'object' && events !== null) {
            // typeof null === 'object', thanks javascript
            this.events = { ...this.events, ...events };
            Object.keys(events).forEach((key) => {
                this.subscribers[events[key]] = [];
            });
        }
    }

    /**
     * Subscribes to a particular event
     * @param {string} eventName
     * @param {Function} callback
     */
    subscribe(eventName, callback) {
        if (eventName == null) return;
        if (!this.subscribers[eventName]) {
            throw new Error('Cannot subscribe to unregistered event.');
        }
        this.subscribers[eventName].push(callback);
    }

    /**
     * Unsubscribes a specific callback function from a particular event
     * @param {string} eventName
     * @param {Function} callback
     */
    unsubscribe(eventName, callback) {
        if (eventName == null) return;
        if (!this.subscribers[eventName]) {
            throw new Error('Cannot unsubscribe to unregistered event.');
        }
        this.subscribers[eventName] = this.subscribers[eventName].filter((cb) => cb !== callback);
    }

    /**
     * Publishes an event to the subscribed subscribers.
     * @param {string} eventName
     * @param data  Data to pass to the callback function
     */
    publish(eventName, data) {
        if (!this.subscribers[eventName]) {
            throw new Error('Cannot publish to unregistered event.');
        }
        this.subscribers[eventName].forEach((callback) => {
            if (typeof callback === 'function') {
                callback(data);
            }
        });
    }
}
